import React from 'react'

const Navbar = () => {
  return (
    <nav id="nav-bar" className="navbar navbar-expand-md fixed-top navbar-light">
      <div className="container-lg">
          <a href="#home" className="navbar-brand">
              <span className="h1">
                  The Curious Developer
              </span>
          </a>

          {/* <!-- Hamburger icon --> */}
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main-nav" 
          aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>  {/* <!-- This className is the hamburger icon --> */}
          </button>

         {/*  <!-- The actual Navbar links --> */}
          <div className="collapse navbar-collapse justify-content-end align-center cus-links" id="main-nav">
              <ul className="navbar-nav">
                  <li className="nav-item">
                      <a href="#home" className="nav-link text-black">Home</a>
                  </li>
                  <li className="nav-item">
                      <a href="#projects" className="nav-link text-black">Projects</a>
                  </li>
                  <li className="nav-item">
                    <a href="#about" className="nav-link text-black">About</a>
                </li>
                  <li className="nav-item">
                      <a href="#contact" className="nav-link text-black">Contact</a>
                  </li>
              </ul>
          </div>
      </div>
  </nav>
  )
}

export default Navbar